import tablePopupInit from '../../../js/src/__page/tablePopup'

// GLOBAL APP CONTROLLER
const controller = {
    init() {},
    loaded() {
        tablePopupInit
    },
    resized() {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
}
export default controller
